<script setup>
/**
 * Layout wrapper that constrains page content to the area below the header.
 *
 * @status recommended
 * @group layout
 * @useWhen Placing between HrLayout and HrPage to handle layout insets
 * @within hr-layout
 * @see https://quasar.dev/layout/page Quasar q-page-container API
 */
defineOptions({ name: 'HrPageContainer' });
</script>

<template>
  <q-page-container v-bind="$attrs">
    <!-- @slot Page content area — typically an HrPage component. -->
    <slot />
  </q-page-container>
</template>
